import React, { createContext, lazy, Suspense, useState } from "react";

const DelayNextBoxModal = lazy(() => import("./Modal"));

export const DelayNextBoxContext = createContext<(memberId: number) => void>(() => {});

export const DelayNextBoxProvider = ({ children }: { children: React.ReactNode }) => {
  const [memberId, setMemberId] = useState<number | null>(null);
  return (
    <DelayNextBoxContext.Provider value={setMemberId}>
      {children}
      {memberId != null && (
        <Suspense fallback={null}>
          <DelayNextBoxModal memberId={memberId} onClose={() => setMemberId(null)} />
        </Suspense>
      )}
    </DelayNextBoxContext.Provider>
  );
};
